module.exports = __webpack_public_path__ + "static/bg-oxaco-6d0bf220a923e59a4a41c2d6a52cd25a.jpg";